import { Link } from "react-router-dom";
import { CalendarDays, Clock3, ArrowLeft,Heart, Eye } from "lucide-react";
import "./articles.css";

export default function ArticleCard({ article }) {
    return (
        <article className="home-article-card">

            <Link
                to={`/articles/${article.slug}`}
                className="home-article-card__image"
            >
                <img
                    src={article.image}
                    alt={article.title}
                    loading="lazy"
                    decoding="async"
                    width="640"
                    height="360"

                    onError={(e) => {
                        e.target.src = "/images/article-placeholder.webp";
                    }}
                />
            </Link>


               <div className="article-card-content">

                                <Link
                                    to={`/articles/${article.slug}`}
                                    className="article-card-title"
                                >
                                    {article.title}
                                </Link>

                                {article.summary && (
                                    <p className="article-card-excerpt">
                                        {article.summary}
                                    </p>
                                )}

                                <div className="article-card-meta">

                                    <span>
                                        {/* نویسنده: {article.writer} */}
                                    </span>



                                </div>
                                <div className="related-articles-footer">
                                    <Link
                                        to={`/articles/${article.slug}`}
                                        className="article-card-read-more"
                                    >
                                        مطالعه مقاله
                                        <span>←</span>
                                    </Link>

                                    <span>
                                        {/* بازدید:{" "} */}
                                        {Number(article.visited).toLocaleString("fa-IR")}
                                        <Eye tooltip="50" size={20} className="eyeIcon" />

                                    </span>
                                </div>



                            </div>

            {/* <div className="home-article-card__content">

                {article.category && (
                    <span className="home-article-card__category">
                        {article.category}
                    </span>
                )}

                <Link
                    to={`/articles/${article.slug}`}
                    className="home-article-card__title"
                >
                    {article.title}
                </Link>

                <p className="home-article-card__summary">
                    {article.summary}
                </p>

                <div className="home-article-card__meta">

                    <span>
                        <CalendarDays size={16} />
                        {article.published_at}
                    </span>

                    <span>
                        <Clock3 size={16} />
                        {article.reading_time} min
                    </span>

                </div>

                <Link
                    to={`/articles/${article.slug}`}
                    className="home-article-card__readmore"
                >
                    Read More

                    <ArrowLeft size={16} />
                </Link>

            </div> */}

        </article>
    );
}